import { QueryKey, useQuery } from "react-query";
import useNetworkHeaders from "../../../permits/components/InspectionsCard/useNetworkHeaders";
import getPublicInspectionById from "../../../queries/inspections/public/getPublicInspectionById";

export default function usePublicInspection({ id, enabled = true }: { id: number | string; enabled?: boolean }) {
  const queryKey = PublicInspectionQueryKey(id);
  const networkHeaders = useNetworkHeaders();
  const inspectionQuery = useQuery(queryKey, getPublicInspectionById(networkHeaders), {
    enabled: id !== undefined && enabled,
  });

  return { data: inspectionQuery.data, isLoading: inspectionQuery.isLoading, isFetching: inspectionQuery.isFetching };
}

export function PublicInspectionQueryKey(id?: number | string): QueryKey {
  return ["inspection-public", id?.toString()].filter((key) => key);
}
